import React from 'react';
import Tippy from '@tippy.js/react';

Tippy.defaultProps = {
  arrow: true,
  inertia: true,
  theme: 'light',
};

export default Tippy;
